import { IconSpinner } from "@tine/designsystem-icons/sharp";
import { Breadcrumbs } from "@tine/designsystem-ui-react";
import { Link, useLocation } from "wouter";
import { logger } from "../../common/logger";
import { isDataAvailable } from "../../common/utils/asyncDataUtils";
import contentStore from "../../stores/cms/contentStore";

const ContentBreadcrumb = () => {
   const [fullUrl] = useLocation();

   if (!isDataAvailable(contentStore.urlData)) {
      return <IconSpinner className="animate-spin" />;
   }

   if (!fullUrl) {
      logger.log("contentful", "Missing parameter 'fullUrl' when rendering breadcrumbs for content");
      return null;
   }

   if (fullUrl === "/") {
      return null;
   }

   if (fullUrl === "/matfaglig" || fullUrl === "/oppskrifter") {
      return null;
   }

   const cleanedFullUrl = fullUrl.startsWith("/") ? fullUrl.slice(1) : fullUrl;

   if (cleanedFullUrl.includes("julekalender")) {
      return null;
   }

   const urlData = contentStore.urlData.data.find((data) => data.slug === cleanedFullUrl || data.fullUrl === cleanedFullUrl);
   const splittedSlugList = urlData?.fullUrl.split("/") ?? cleanedFullUrl.split("/");
   const items = splittedSlugList.map((slug, index, arr) => {
      const urlData = contentStore.urlData.data.find((urlData) => urlData.slug === slug);

      return {
         label: urlData?.title || "",
         href: `/${urlData?.fullUrl}`,
         current: index === arr.length - 1,
         as: Link
      };
   });

   const breadcrumbItems = [{ label: "Hjem", href: "/", as: Link }, ...items];

   const filteredBreadcrumbItems = breadcrumbItems.filter((item) => {
      return !!item.href && item.href !== "/undefined";
   });

   return (
      <div className="mt-2 mb-4 print:hidden">
         <Breadcrumbs items={filteredBreadcrumbItems} />
      </div>
   );
};

export default ContentBreadcrumb;
